<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal d-modal--width text-dark" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Vælg jeres lønsystem</h2>
      </div>
      <div class="d-modal__content">
        <div class="loader-container" v-if="isLoading">
          <Loader bgColor="#f6f9fc"></Loader>
        </div>
        <div class="d-boxes" v-else>
          <div class="d-boxes__box"
               :class="{'d-boxes__box--selected': selected === system.value}"
               v-for="system in systems" :key="system.value"
               @click="selected = system.value">
            <input type="radio"
                   v-model="selected"
                   :value="system.value"
                   :id="'d-boxes__box_' + system.value">
            <label :for="'d-boxes__box_' + system.value" v-html="system.name"></label>
          </div>
        </div>
      </div>
      <div class="do-modal__footer">
        <button
          class="do-bttn do-bttn--submit"
          :class="{ 'do-bttn--submit--loading': isLoading }"
          @click="submit"
        >
          {{ $t('vue2.common.save') }}
        </button>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import docendo from '../../docendo'
import Loader from '../common/Loader.vue'

export default {
  components: {Loader, DModal},
  props: {
    schoolId: {}
  },
  data () {
    return {
      isLoading: false,
      selected: 'KMD',
      systems: [
        {value: 'KMD', name: 'KMD OPUS'},
        {value: 'SD', name: 'SD LØN'}
      ]
    }
  },
  methods: {
    select (system) {
      this.selected = system.value
    },
    submit () {
      this.isLoading = true
      const updates = {salary_system: this.selected}
      docendo.updateSchool(this.schoolId, updates, success => {
        this.$store.commit('setActiveSchool', success)
      }, failure => {
        console.log({failure})
      })
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-boxes {
  display: flex;
  flex-direction: column;
}

.d-box-select {
  flex: 1;
  min-height: 150px;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 0 0 4px 4px;
  cursor: pointer;
}

.d-box-select:first-child {
  border-bottom: none;
  border-radius: 4px 4px 0 0;
}

.d-box-select:hover {
  background: aliceblue;
  border-color: var(--primary);
}

.d-modal--width {
  width: 500px;
}

.d-boxes__box {
  position: relative;
  display: inline-flex;
  align-items: center;
  line-height: 16px;
  height: 75px;
  transition: color 0.25s;
  cursor: pointer;
  padding: 1rem;
  margin-bottom: 0;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-width: 1px 1px 0 1px;
}

.d-boxes__box.d-boxes__box--selected + .d-boxes__box {
  border-top: none;
}

.d-boxes__box.d-boxes__box--selected,
.d-boxes__box.d-boxes__box--selected:last-child {
  background: #eff2ff;
  border: 1px solid #c8d2fe;
}

.d-boxes__box > input[type="radio"] {
  width: auto;
  padding-right: 8px;
}

.d-boxes__box > input[type="radio"]:checked + label {
  color: var(--dark-blue);
}

.d-boxes__box label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
  font-size: 12px;
  padding-left: 10px;
  cursor: pointer;
  transition: color 0.25s;
  letter-spacing: .075rem;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1rem;
  color: #a2a3a6;
}

.d-boxes__box:hover label {
  color: var(--dark-blue);
}

.d-boxes__box:first-child {
  border-radius: 4px 4px 0 0;
}
.d-boxes__box:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 1px solid #e5e7eb;
}

.d-boxes__box:only-child {
  border-radius: 4px;
}

.do-modal__footer {
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// ChooseSalarySystem.vue?3331632d